import { readSerializedContext } from '@ms-cloudpack/api-server';
import type { CloudpackConfig } from '@ms-cloudpack/common-types';
import { augmentAppConfig, type ReadConfigOptions } from '@ms-cloudpack/config';

/**
 * Read remote configs from the `cloudpack-context.json` from multiple paths, and augment with
 * the given options.
 */
export async function readRemoteConfigs(
  appPaths: string[],
  readConfigOptions: ReadConfigOptions,
): Promise<Record<string, CloudpackConfig>> {
  const configs: Record<string, CloudpackConfig> = {};

  for (const appPath of appPaths) {
    const cloudAppContext = await readSerializedContext(appPath);
    configs[appPath] = augmentAppConfig(cloudAppContext.config, readConfigOptions);
  }

  return configs;
}
